import { hotRanking } from "@/mocks/home";

const trendMap: Record<string, { icon: string; cls: string }> = {
  up: { icon: "ri-arrow-up-line", cls: "text-primary-600" },
  down: { icon: "ri-arrow-down-line", cls: "text-foreground-400" },
  flat: { icon: "ri-subtract-line", cls: "text-foreground-400" },
};

export default function HotRanking() {
  const top3 = hotRanking.filter((item) => item.rank <= 3);
  const rest = hotRanking.filter((item) => item.rank > 3);

  return (
    <section id="ranking" className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-primary-600">Hot Board</span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">热议榜</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              依据近 24 小时的讨论量与转发量综合计算，榜位实时浮动，只作为围观顺序参考。
            </p>
          </div>
          <span className="flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-refresh-line text-sm"></i>
            每 30 分钟刷新一次
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-3">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:col-span-1 lg:grid-cols-1">
            {top3.map((item) => (
              <article
                key={item.rank}
                className="relative flex flex-col justify-between overflow-hidden rounded-lg bg-gradient-to-br from-primary-500 to-secondary-500 p-5 text-background-50 cursor-pointer"
              >
                <div className="flex items-start justify-between">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/25 font-heading text-lg font-black">
                    {item.rank}
                  </span>
                  <span className="rounded-md bg-background-50/25 px-2 py-0.5 text-[11px] font-semibold">
                    {item.tag}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold leading-snug">{item.title}</h3>
                <div className="mt-3 flex items-center gap-1.5 text-sm font-semibold text-white">
                  <i className="ri-fire-fill text-accent-400"></i>
                  {item.heat}
                </div>
              </article>
            ))}
          </div>

          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100 lg:col-span-2">
            <div className="flex items-center justify-between border-b border-background-200 px-5 py-4">
              <span className="font-heading text-sm font-bold text-foreground-950">榜单 · 第 4 – 10 位</span>
              <span className="text-xs text-foreground-500">热度 / 趋势</span>
            </div>
            <ul>
              {rest.map((item, index) => (
                <li key={item.rank}>
                  <a
                    href="#latest"
                    className={`flex items-center gap-4 px-5 py-4 transition-colors hover:bg-background-50 cursor-pointer ${
                      index !== rest.length - 1 ? "border-b border-background-200/80" : ""
                    }`}
                  >
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-background-300/70 font-heading text-sm font-black text-foreground-700">
                      {item.rank}
                    </span>
                    <span className="flex-1 font-medium text-foreground-900">{item.title}</span>
                    <span className="hidden shrink-0 rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] font-semibold text-secondary-900 sm:inline-block">
                      {item.tag}
                    </span>
                    <span className="flex w-20 shrink-0 items-center justify-end gap-1 text-sm font-semibold text-foreground-700">
                      <i className={`${trendMap[item.trend].icon} ${trendMap[item.trend].cls}`}></i>
                      {item.heat}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}